
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weekly-promotions",
      function () {
        return require("private-next-pages/weekly-promotions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weekly-promotions"])
      });
    }
  